import React, { useEffect, useLayoutEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { useDispatch } from "react-redux";
import { storeAuth } from "store/slices/authSlice";
import axios, { setAuthToken } from "common/configs/axiosConfigs";

const RootLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSidebarShown, setIsSidebarShown] = useState(window.innerWidth > 768);

  const user = JSON.parse(localStorage.getItem("user-auth") || null);
  useEffect(() => {
    if (user) {
      dispatch(storeAuth(user));
      if ((user.role_id === 1 || user.role_id === 2) && user.is_register === 0) {
        navigate("/company-details");
      }
    } else {
      navigate("/login");
    }
  }, []);
  useLayoutEffect(() => {
    if (user?.token) setAuthToken(user?.token);
  }, []);
  const checkUser = async () => {
    if (user?.email)
      try {
        const { data } = await axios.post("", {
          action: "checkUserEmail",
          email: user?.email,
        });
        if (!data.success) {
          localStorage.removeItem("user-auth");
          dispatch(storeAuth(null));
          navigate("/login");
        } else {
          localStorage.setItem(
            "user-auth",
            JSON.stringify({ ...user, company_id: data?.data?.companyId })
          );
        }
      } catch (err) {
        console.error("ERROR:", err);
      }
  };
  useEffect(() => {
    checkUser();
  }, []);
  return (
    <>
      <Sidebar {...{ className: isSidebarShown ? "shown" : "" }} />
      <div className="sidebar-backdrop" onClick={() => setIsSidebarShown(false)}></div>
      <main>
        <Header {...{ isSidebarShown, setIsSidebarShown }} />
        <Outlet />
      </main>
    </>
  );
};

export default RootLayout;
